// Event emitter per gestire gli eventi dei cataloghi
class CatalogEventEmitter {
    constructor() {
        this.events = {};
    }

    // Registra un listener per un evento
    on(eventName, callback) {
        if (!this.events[eventName]) {
            this.events[eventName] = [];
        }
        this.events[eventName].push(callback);
    }

    // Rimuove un listener per un evento
    off(eventName, callback) {
        if (!this.events[eventName]) return;
        this.events[eventName] = this.events[eventName].filter(cb => cb !== callback);
    }

    // Emette un evento
    emit(eventName, data) {
        if (!this.events[eventName]) return;
        this.events[eventName].forEach(callback => {
            try {
                callback(data);
            } catch (error) {
                console.error(`Error in catalog event listener for ${eventName}:`, error);
            }
        });
    }

    // Rimuove tutti i listener per un evento
    removeAllListeners(eventName) {
        if (eventName) {
            delete this.events[eventName];
        } else {
            this.events = {};
        }
    }
}

// Istanza singleton dell'event emitter
const catalogEvents = new CatalogEventEmitter();

// Eventi disponibili
export const CATALOG_EVENTS = {
    CATALOG_PUBLISHED: 'catalog_published',
    CATALOG_UPDATED: 'catalog_updated',
    CATALOG_DELETED: 'catalog_deleted',
    CATALOGS_REFRESHED: 'catalogs_refreshed'
};

export default catalogEvents; 